var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c(_vm.rowFile,{tag:"component",attrs:{"form-group-class":[_vm.data.width, _vm.data.class ? _vm.data.class : 'col-md-12'],"label":_vm.$trans(_vm.row.name),"answers":_vm.answers,"row":_vm.row},model:{value:(_vm.answer),callback:function ($$v) {_vm.answer=$$v},expression:"answer"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }